// components/Methodology.js (actualizado)
import React from 'react';
import ScrollAnimation from './ScrollAnimation';

const Methodology = () => {
    const steps = [
        {
            title: "Diagnóstico institucional",
            description: "Escuchamos, analizamos y comprendemos las necesidades del organismo.",
            icon: "🔍"
        },
        {
            title: "Diseño y planificación",
            description: "Definimos objetivos, funcionalidades y etapas con participación del cliente.",
            icon: "📋"
        },
        {
            title: "Desarrollo ágil",
            description: "Construimos y testeamos de forma iterativa para garantizar calidad y usabilidad.",
            icon: "⚡"
        },
        {
            title: "Implementación y soporte",
            description: "Acompañamos el proceso de adopción y brindamos asistencia continua.",
            icon: "🛠️"
        }
    ];

    return (
        <section id="metodologia" className="py-16 bg-gray-50">
            <div className="container mx-auto px-6">
                <ScrollAnimation>
                    <h2 className="text-3xl font-bold font-poppins text-grafito mb-8 text-center">Nuestra metodología</h2>
                </ScrollAnimation>
                <div className="max-w-4xl mx-auto">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                        {steps.map((step, index) => (
                            <ScrollAnimation key={index} delay={0.2 + index * 0.1}>
                                <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow border-l-4 border-cyan">
                                    <div className="flex items-center mb-4">
                                        <span className="text-2xl mr-3">{step.icon}</span>
                                        <h3 className="text-xl font-semibold font-montserrat text-cyan">{step.title}</h3>
                                    </div>
                                    <p className="text-grafito font-lato">{step.description}</p>
                                </div>
                            </ScrollAnimation>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Methodology;
